import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./tag.css.ts.vanilla.css-mistica.js";
var _ = "_1wy08671 _1y2v1nf7j _1y2v1nf8s _1y2v1nfhl _1y2v1nfhp _1y2v1nfhz _1y2v1nfht _1y2v1nfjg";
export { _ as tag };
